import { isValidUrl } from "context";
import React, { useCallback, useState } from "react";
import {
  Button,
  Input,
  InputGroup,
  Modal,
  ModalBody,
  Spinner,
} from "reactstrap";
import debounce from "lodash.debounce";
import { getAthleteDataById } from "store/actions/athleteActions";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { updateContestVideoData } from "store/actions/contestAction";
import { addContestVideo } from "store/actions/contestAction";
import firebase from "../../config/firebase";

const AddBrandAmbassadorVideoModal = ({
  modal,
  toggleModal,
  athleteList,
  setAthleteList,
  contestVideoId,
  contestId,
  docId,
  urls,
  setUrls,
  getContestVideoLoader,
  setUpdateDocument,
  updateDocument,
}) => {
  const dispatch = useDispatch();
  const { uid, user } = useSelector((state) => state.auth);
  const [urlInput, setUrlInput] = useState("");
  const [searchLoader, setSearchLoader] = useState(false);
  const [athleteListLoader, setAthleteListLoader] = useState(false);
  const [modalBtnLoader, setModalBtnLoader] = useState(false);
  const isValidUrl = (url) => {
    const youTubeRegex = new RegExp(
      "^(https?://)?(www\\.)?(youtube\\.com|you\\.tube|youtu\\.be)/(watch\\?v=|embed/|v/|.+/|\\?v=)?([a-zA-Z0-9_-]{11})$"
    );
    return youTubeRegex.test(url);
  };

  const AddUrl = (fullUrl) => {
    if (urls.length < 8) {
      const exists = urls.some((url) => url === fullUrl);

      if (exists) {
        toast.error("This URL already exists.");
      } else {
        if (isValidUrl(fullUrl)) {
          setUrls([...urls, fullUrl]);
        } else {
          toast.warning("Add only YouTube URLs");
        }
      }
      setTimeout(() => {
        setUrlInput("");
      }, 500);
    } else {
      toast.error("You have reached the maximum limit of adding Videos");
    }
  };

  const removeUrl = (fullUrl) => {
    setUrls((prevUrl) => prevUrl.filter((url) => url !== fullUrl));
  };

  const parseUrl = (fullUrl) => {
    const parsedUrl = new URL(fullUrl);

    const desiredPart = `${parsedUrl.protocol}//${parsedUrl.hostname}${parsedUrl.pathname}`;

    return desiredPart;
  };

  const handleAthleteSearch = useCallback(
    debounce(async (e) => {
      try {
        setAthleteListLoader(true);
        setSearchLoader(true);

        const inputVal = e.target.value;
        setSearchLoader(true);
        e.target.value = "";
        await dispatch(
          getAthleteDataById(Number(inputVal), (athleteData) => {
            if (athleteList.length < 5) {
              if (athleteData) {
                const exists = athleteList.some(
                  (athlete) => athlete.athleteId === athleteData.athleteID
                );
                if (exists) {
                  toast.info("Athlete Already exists in the List");
                }
                if (!exists) {
                  setAthleteList((prevAthleteList) => [
                    ...prevAthleteList,
                    {
                      athleteName:
                        athleteData.first_name + " " + athleteData.last_name,
                      athleteId: athleteData.athleteID,
                      athlete_Id: athleteData.id,
                    },
                  ]);
                }
              } else {
                toast.error(`No Athlete is Found with the Id:${inputVal}`);
              }
            } else {
              toast.error("You reached the maximum limit of adding athletes");
            }
            setAthleteListLoader(false);
            e.target.value = "";
            setSearchLoader(false);
          })
        );
      } catch (error) {
        e.target.value = "";
        setSearchLoader(false);
        console.error("An error occurred:", error);
      }
    }, 3000),
    [athleteList, dispatch]
  );

  const removeAthlete = (athleteId) => {
    if (Number(athleteId) !== user.athleteID) {
      setAthleteList((prevAthleteList) =>
        prevAthleteList.filter((athlete) => athlete.athleteId !== athleteId)
      );
    }
  };

  const handleSubmit = () => {
    setModalBtnLoader(true);
    let data = [];

    athleteList.length > 0 &&
      athleteList.map((athlete) => {
        data.push(athlete.athlete_Id);
      });
    if (urls.length == 0) {
      toast.error("Please add minimum of 1 video");
      setModalBtnLoader(false);
    } else {
      if (updateDocument) {
        const data1 = {
          videoUrl: urls,
          participantList: data,
        };
        dispatch(
          updateContestVideoData(contestVideoId, data1, () => {
            toast.success("Data Update Sucessfully");
            toggleModal();
            setModalBtnLoader(false);
            setUpdateDocument(false);
          })
        );
      } else {
        const data1 = {
          contestEnrollmentId: docId,
          contest_id: contestId,
          videoUrl: urls,
          votes: 0,
          participantList: data,
          createdAt: firebase.firestore.Timestamp.now(),
          athleteId: uid,
        };

        dispatch(
          addContestVideo(data1, (res) => {
            if (res) {
              toast.success(`Video Added successfully`);
            }
            toggleModal();
            setModalBtnLoader(false);
          })
        );
      }
    }
  };

  return (
    <Modal isOpen={modal} toggle={toggleModal} size="lg">
      <ModalBody>
        {getContestVideoLoader && (
          <div className="custom-table-body p-3 d-flex justify-content-center">
            <Spinner size={"md"} />
          </div>
        )}
        {!getContestVideoLoader && (
          <>
            <InputGroup className="w-100  mb-3 mt-3">
              <div className="w-100 d-flex align-items-center">
                <label className="w-max mr-2">Add video url: </label>
                <Input
                  type="text"
                  className="w-50"
                  invalid={!isValidUrl(urlInput) && urlInput}
                  placeholder="  Add video Url"
                  value={urlInput}
                  onChange={(e) => {
                    setUrlInput(e.target.value);
                    isValidUrl(e.target.value) && AddUrl(e.target.value);
                  }}
                />
              </div>
              {!isValidUrl(urlInput) && urlInput && (
                <small className="text-center text-danger pt-1">
                  Please add only youtube urls
                </small>
              )}
            </InputGroup>
            <div className="d-flex flex-wrap">
              {urls.length > 0 ? (
                urls.map((url, index) => (
                  <div
                    className="rounded-pill position-relative"
                    key={index + 500}
                  >
                    <i
                      class="fa fa-times-circle position-absolute close-circle"
                      onClick={() => {
                        removeUrl(url);
                      }}
                      aria-hidden="true"
                    ></i>
                    <span className="">
                      <a href={url} target="_blank">
                        {url && url !== "" && parseUrl(url)}
                      </a>
                    </span>
                  </div>
                ))
              ) : (
                <div className="w-100 d-flex justify-content-center m-3">
                  Add Video Urls
                </div>
              )}
            </div>

            <InputGroup className="w-100  mb-3 mt-3">
              <div className="w-100 d-flex align-items-center">
                <label className="w-max mr-2">Search Athlete By ID: </label>
                <Input
                  type="number"
                  className="w-50"
                  placeholder="  Search..."
                  disabled={searchLoader}
                  onChange={(e) => {
                    handleAthleteSearch(e);
                  }}
                />
              </div>
            </InputGroup>

            {athleteListLoader ? (
              <div className="w-100 d-flex justify-content-center m-4">
                <Spinner size={"md"} />
              </div>
            ) : (
              <div className="d-flex flex-wrap">
                {athleteList.length > 0 ? (
                  athleteList.map((athlete, index) => (
                    <div className="rounded-pill position-relative">
                      {index !== 0 && (
                        <i
                          class="fa fa-times-circle position-absolute close-circle"
                          onClick={() => {
                            removeAthlete(athlete?.athleteId);
                          }}
                          aria-hidden="true"
                        ></i>
                      )}
                      <span className="">{athlete.athleteName}</span>
                    </div>
                  ))
                ) : (
                  <div className="w-100 d-flex justify-content-center m-3">
                    Search An Athlete By Their Id
                  </div>
                )}
                <div className="w-100 d-flex justify-content-end">
                  <Button
                    id="block"
                    size="md"
                    color="primary"
                    className="btn"
                    disabled={modalBtnLoader}
                    onClick={() => {
                      setModalBtnLoader(true);

                      handleSubmit();
                    }}
                  >
                    {modalBtnLoader ? (
                      <Spinner size={"sm"} />
                    ) : (
                      <>
                        <i class="fa fa-xmark"></i>
                        Add
                      </>
                    )}
                  </Button>
                </div>
              </div>
            )}
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

export default AddBrandAmbassadorVideoModal;
